export const getPriceWiseItinerary = (data, price) => {
    if (!price?.min && !price?.max) return data;
    return data?.filter(itinerary => {
        const newAmount = itinerary?.estimated_Cost;
        return newAmount >= price?.min && newAmount <= price?.max;
    }).sort((a, b) => a.estimated_Cost - b.estimated_Cost);
};

export const getDaysWiseItinerary = (data, days) => {
    if (!days?.min && !days?.max) return data;
    return data?.filter(itinerary => {
        const totalDays = itinerary?.total_days;
        return (
            (days?.min === undefined || totalDays >= days?.min) &&
            (days?.max === undefined || totalDays <= days?.max)
        );
    }).sort((a, b) => a.total_days - b.total_days);
}

export const getRatingWiseItinerary = (data, ratings) => {
    if (!Array.isArray(ratings) || ratings.length === 0) return data;
    const parseRange = (range) => {
        const parts = range.split('-').map(Number);
        if (parts.length === 1) return [parts[0], parts[0]];
        return [Math.min(...parts), Math.max(...parts)];
    };
    return data?.filter((itinerary) => {
        return ratings.some((rating) => {
            const [min, max] = parseRange(rating);
            return itinerary?.avg_rating >= min && itinerary?.avg_rating <= max;
        });
    }).sort((a, b) => a.avg_rating - b.avg_rating);
}

export const getTravellersWiseItinerary = (data, travellerType) => {
    if (!Array.isArray(travellerType) || travellerType.length === 0) return data;
    return data?.filter((itinerary) => travellerType?.includes(itinerary.travellers_type));
}

export const getDateWiseItinerary = (data, dates) => {
    if (dates?.status !== true) return data;
    const startDate = new Date(dates?.startDate).toISOString();
    const endDate = new Date(dates?.endDate).toISOString();

    return data.filter((itinerary) => {
        const firstDestinationDate = itinerary.destinationCityDetails[0].tour_start_date;
        const lastDestinationDate = itinerary.destinationCityDetails[itinerary.destinationCityDetails.length - 1].tour_start_date;
        return firstDestinationDate >= startDate && lastDestinationDate <= endDate;
    });
};

export const getCountryWiseItinerary = (data, country) => {
    if (!country || !country.name) return data;
    return data.filter((itinerary) =>
        itinerary.total_destination_city.some(
            (destination) => destination.country === country.name
        )
    );
}

export const getCityWiseItinerary = (data, cities) => {
    if (!Array.isArray(cities) || cities.length === 0) return data;
    const citiesArr = cities.map((city) => city.name);

    return data.filter((itinerary) =>
        itinerary.total_destination_city.some((destination) =>
            citiesArr.includes(destination.city)
        )
    );
};

export const sortWiseItinerary = (data, sortType) => {
    // console.log("sortWiseItinerary===>", data)
    return [...data].sort((a, b) => {
        switch (sortType) {
            case 'Recent':
                return new Date(b.createdAt) - new Date(a.createdAt);
            case 'Popularity':
                return b.total_rating - a.total_rating;
            case 'Price (Low to High)':
                return (a.currencyConvert?.new_amount || 0) - (b.currencyConvert?.new_amount || 0);
            case 'Price (High to Low)':
                return (b.currencyConvert?.new_amount || 0) - (a.currencyConvert?.new_amount || 0);
            default:
                return 0;
        }
    });
};